import React, { useState, useEffect } from "react";
import "./l002.css";
import "reactjs-popup/dist/index.css";
import "react-html5video/dist/styles.css";
import Web3D from "../l002/webThreeD";
import Configurator from "../l002/configurator";
import SignUp from "./signUp";
import SignIn from "./signIn";

// const U400 = ({ onConfigurator, configurator, expand }) => {

const U400 = ({
  setLayoutIndex,
  layoutIndex,
  setExpand,
  fullScreen,
  setUserAuth,
  userAuth,
  token,
  setResetConfig,
  resetConfig,
  onResetStatus,
  setOnResetStatus,
}) => {
  // const [userAuth, setUserAuth] = useState("signin");
  // const [token, setToken] = useState("");

  let curPage = window.location.pathname;

  // useEffect(() => {
  //   const tokenId = JSON.parse(sessionStorage.getItem("token"));
  //   setToken(tokenId);
  // }, [userAuth, layoutIndex]);

  // useEffect(() => {
  //   const expirationTimer = setTimeout(() => {
  //     sessionStorage.setItem("token", JSON.stringify(""));
  //     sessionStorage.setItem("userDetails", JSON.stringify(""));
  //     setUserAuth("e");
  //   }, 3 * 60 * 1000);
  //   return () => clearTimeout(expirationTimer);
  // }, []);

  // const [colorData, setColorData] = useState([]);
  // const [configurator, setConfigurator] = useState(0);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   axios
  //     .get(
  //       "https://zeblobstorage.blob.core.windows.net/zeblob/ProjectDb/Tvs/NewAchri/L002_tvsmotor/L002B/Custom_Configurator.json"
  //     )
  //     .then((response) => {
  //       dispatch(setCustomConfigData(response?.data));
  //     });
  // }, []);
  // const meshUrl =
  //   "https://zdviewerassets.blob.core.windows.net/zdviewer/Layout.json";
  // // "https://zeblobstorage.blob.core.windows.net/zeblob/ProjectDb/Tvs/Json/MeshData.json"; //BaseUrl + "MeshData.json";

  // useEffect(() => {
  //   onMeshData();
  // }, [configurator]);
  // useEffect(() => {
  //   onMeshData();
  // }, []);

  // const onMeshData = () => {
  //   //This function call Mesh Data API
  //   axios.get(meshUrl).then((response) => {
  //     response?.data?.layouts?.filter((item) => {
  //       if (pid === "RR310" && item?.lId === "L001") {
  //         dispatch(setMeshData(JSON.parse(JSON.stringify([item]))));
  //         onHotspot(response?.data?.baseUri + item?.hotspot);
  //       }
  //       if (!configurator && pid === "U400" && item?.lId === "L002A") {
  //         dispatch(setMeshData(JSON.parse(JSON.stringify([item]))));
  //         onHotspot(response?.data?.baseUri + item?.hotspot);
  //       }
  //       if (configurator && pid === "U400" && item?.lId === "L002B") {
  //         dispatch(setMeshData(JSON.parse(JSON.stringify([item]))));
  //         onHotspot(response?.data?.baseUri + item?.hotspot);
  //       }
  //     });
  //   });
  // };

  // const onHotspot = (url) => {
  //   axios.get(url).then((response) => {
  //     dispatch(setHotspotData(response?.data));
  //   });
  // };

  // const onConfigurator = (index) => {
  //
  //   setConfigurator(index);
  //   setLayoutIndex(index);
  // };

  // useEffect(() => {
  //   axios({
  //     method: "post",
  //     url: "https://preprod-www.tvsmotor.com/sitecore/api/getallecomproducts",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: {
  //       categoryType: ["accessories", "merchandise"],
  //       categoryCode: [],
  //       genderfacet: [],
  //       segment: [],
  //       colorfacet: "",
  //       vehicleCode: "u400",
  //       pageNumber: 0,
  //       pageSize: 100,
  //     },
  //   }).then((res) => {
  //

  //     const data = res.data;
  //     if (data?.isSuccess) {
  //
  //     } else {
  //
  //     }
  //   });
  // }, []);

  return (
    <>
      {layoutIndex === 0 ? (
        <Web3D
          onConfigurator={setLayoutIndex}
          setExpand={setExpand}
          fullScreen={fullScreen}
        />
      ) : (
        <>
          {curPage.includes("RTR310Launch") ? (
            <Configurator
              onConfigurator={setLayoutIndex}
              setExpand={setExpand}
              fullScreen={fullScreen}
              setResetConfig={setResetConfig}
              resetConfig={resetConfig}
              onResetStatus={onResetStatus}
              setOnResetStatus={setOnResetStatus}
            />
          ) : (
            <>
              {token ? (
                <Configurator
                  onConfigurator={setLayoutIndex}
                  setExpand={setExpand}
                  fullScreen={fullScreen}
                  setResetConfig={setResetConfig}
                  resetConfig={resetConfig}
                  onResetStatus={onResetStatus}
                  setOnResetStatus={setOnResetStatus}
                />
              ) : (
                <>
                  {userAuth === "signin" ? (
                    <SignIn
                      onUserAuth={setUserAuth}
                      setExpand={setExpand}
                      fullScreen={fullScreen}
                      onConfigurator={setLayoutIndex}
                    />
                  ) : (
                    <SignUp
                      onUserAuth={setUserAuth}
                      setExpand={setExpand}
                      fullScreen={fullScreen}
                      onConfigurator={setLayoutIndex}
                    />
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default U400;
